
import React from 'react';
import { HStack, VStack, Text, Flex, FormSpacer } from '@cad-arc';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { isValidLatLng } from '../location/helpers';
import { FormNumberInput } from '../forms/integrated-form-controls/form-number-input';
import { FormSection } from '../search-windows/form-section';
import { LocationRadiusSearchMap } from '../search-windows/location-radius-search-map';
import { LocationSearchMapPlaceholder } from '../search-windows/location-search-map-placeholder';
import { validateLatitude, validateLongitude } from '../search-windows/utils';
import { SearchLocationForm } from './types';

export function SearchFormRadiusSearchSection({
    form,
}: Readonly<{
    form: UseFormReturn<SearchLocationForm>;
}>) {
    const { latitude, longitude, radiusInFeet } = useWatch({
        control: form.control,
        name: 'locations.0',
    });
    const isValid = isValidLatLng(latitude, longitude) && radiusInFeet && radiusInFeet >= 0;
    return (
        <HStack
            data-testid="radius-search-section"
            w="100%"
            justifyContent="space-between"
            alignItems="flex-start"
        >
            <VStack align="left">
                <Text variant="headingXs">Radius Search</Text>
                <FormSection>
                    <Flex w="360px" gap={4}>
                        <FormNumberInput
                            name="locations.0.latitude"
                            label="Latitude"
                            control={form.control}
                            length="md"
                            rules={{
                                validate: validateLatitude,
                            }}
                        />
                        <FormNumberInput
                            name="locations.0.longitude"
                            label="Longitude"
                            control={form.control}
                            length="md"
                            rules={{
                                validate: validateLongitude,
                            }}
                        />
                    </Flex>
                    <Flex w="360px" gap={4}>
                        <FormNumberInput
                            name="locations.0.radiusInFeet"
                            label="Radius (Feet)"
                            control={form.control}
                            length="md"
                            rules={{
                                validate: (radiusInFeet) => {
                                    if (!radiusInFeet) {
                                        return;
                                    }
                                    if (parseInt(radiusInFeet) < 0) {
                                        return 'Cannot be less than 0';
                                    }
                                },
                            }}
                            numberInputProps={{
                                precision: 0,
                            }}
                        />
                        <FormSpacer w="full" />
                    </Flex>
                </FormSection>
            </VStack>
            {latitude && longitude && radiusInFeet && isValid ? (
                <LocationRadiusSearchMap
                    center={{ latitude, longitude }}
                    radiusInFeet={radiusInFeet}
                />
            ) : (
                <LocationSearchMapPlaceholder />
            )}
        </HStack>
    );
}
